export function embedChatbot(chatEle,chatSrc,chatApiKey,chatApi,chatMethod="POST",chatTitle,MessageIcon,openOrign="window",themeColor="#2259FD") {
/*   const chatEle = document.getElementById("chatbot-iframe");
  //iframe链接（必传）
  let chatSrc = chatEle.getAttribute("data-src");
  //iframe标题（必传）
  const chatTitle = chatEle.getAttribute("data-title");
  //知识库API（必传）
  let chatApi = chatEle.getAttribute("data-api");
  //请求方式（可选 默认POST）
  let chatMethod = chatEle.getAttribute("data-method")
    ? chatEle.getAttribute("data-method")
    : "POST";
  //知识库API Key（必传）
  let chatApiKey = chatEle.getAttribute("data-api-key");
  //打开方式（可选 默认window）
  let openOrign = chatEle.getAttribute("data-open-origin")
    ? chatEle.getAttribute("data-open-origin")
    : "window";
  //打开图标（可选 默认https://ego-image-hosting.oss-accelerate.aliyuncs.com/image/move-ai-2024-08-29.png）
  const MessageIcon =
    chatEle?.getAttribute("data-open-icon") ||
    `https://ego-image-hosting.oss-accelerate.aliyuncs.com/image/move-ai-2024-08-29.png`; */

  //主题样式(可选)
  chatEle.style.display = "none";
  if (!chatSrc || !chatApi) {
    console.error(`Can't find appid`);
    return;
  }
  console.log("chatEle", chatEle);
 
  /* 电脑端 */
  if (openOrign == "window") {
    /* 浮动按钮 {打开} */
    const ChatBtn = document.createElement("div");
    ChatBtn.id = "chat-btn-open";
    ChatBtn.style.cssText =
      "position: fixed; bottom: 60px; right: 30px; width: 68px; height: 68px; cursor: pointer; z-index: 2147483647; transition: 0;";
    ChatBtn.style.background = `url(${MessageIcon}) no-repeat`;
    ChatBtn.style.backgroundSize = "100% 100%";

    /* iframe框 */
    let params = {
      api: chatApi,
      method: chatMethod,
      title: chatTitle,
      avatar: MessageIcon,
      theme: themeColor,
    };
    for (let key in params) {
      chatSrc += "&" + key + "=" + encodeURIComponent(params[key]);
    }
    chatSrc = chatSrc.replace("&", "?");

    let iframe = document.createElement("iframe");
    iframe.src = chatSrc;
    iframe.id = "fastgpt-chatbot-iframe";
    iframe.title = chatTitle;
    iframe.frameBorder = "no";
    iframe.style.cssText =
      "position: fixed; bottom: 60px; right: 98px;width: 460px;height: 700px;visibility:hidden;z-index:9999;";
    document.body.appendChild(iframe);
    ChatBtn.addEventListener("click", function () {
      const ChatIframe = document.getElementById("fastgpt-chatbot-iframe");
      if (ChatIframe.style.visibility === "hidden") {
        const iframeKeyframes = [
          {
            transform: `translateY(600px)`,
            opacity: 0,
          },

          {
            transform: `translateY(0px)`,
            opacity: 1,
          },
        ];

        const effect = new KeyframeEffect(ChatIframe, iframeKeyframes, {
          duration: 300,
          fill: "forwards",
        });
        const animation = new Animation(effect);
        animation.play();
        ChatIframe.style.visibility = "visible";
      } else {
        console.log("close", ChatIframe.style.visibility);
        ChatIframe.style.visibility = "hidden";
      }
    });
    document.body.appendChild(ChatBtn);
  } else {
    /* 手机端 */
    let params = {
      api: chatApi,
      method: chatMethod,
      title: chatTitle,
      avatar: MessageIcon,
      theme: themeColor,
    };

    for (let key in params) {
      chatSrc += "&" + key + "=" + encodeURIComponent(params[key]);
    }
    chatSrc = chatSrc.replace("&", "?");
    console.log(chatSrc);
    let iframe = document.createElement("iframe");
    iframe.src = chatSrc;
    iframe.id = "fastgpt-chatbot-iframe";
    iframe.title = chatTitle;
    iframe.style.height = "100%";
    iframe.style.width = "100%";
    iframe.style.border = "none";

    /*  iframe.setAttribute("defaultOpen", defaultOpen); */
    document.body.appendChild(iframe);
  }
}
